import type { InfoGridField } from 'v2/components/InfoGrid/types';

import type { AccountUser, MyInformationLabels } from './types';

export const TEST_ID = 'accountDetailsSection';

const PHONE_PATTERN = /^(\d{3})(\d{3})(\d{4})$/;

const AREA_CODE_GROUP = 1;

const PREFIX_GROUP = 2;

const LINE_NUMBER_GROUP = 3;

export const ROLE_SEPARATOR = ', ';

export const formatPhoneNumber = (phoneNumber?: string | null): string => {
    if (!phoneNumber) {
        return '';
    }

    const phoneSections = phoneNumber.match(PHONE_PATTERN);

    if (phoneSections === null) {
        return phoneNumber;
    }

    return `(${phoneSections[AREA_CODE_GROUP]}) ${phoneSections[PREFIX_GROUP]}-${phoneSections[LINE_NUMBER_GROUP]}`;
};

const toInfoGridFields = (
    fields: { fullWidth?: boolean; label: string; value: string }[],
    notProvidedText: string
): InfoGridField[] =>
    fields.map(({ fullWidth, label, value }) => ({
        empty: !value,
        fullWidth,
        label,
        value: value || notProvidedText
    }));

export const buildMyInformationFields = (
    user: AccountUser,
    labels: MyInformationLabels,
    notProvidedText: string
): InfoGridField[] =>
    toInfoGridFields(
        [
            { label: labels.firstName, value: user?.firstName ?? '' },
            { label: labels.lastName, value: user?.lastName ?? '' },
            { fullWidth: true, label: labels.email, value: user?.email ?? '' },
            {
                fullWidth: true,
                label: labels.phone,
                value: formatPhoneNumber(user?.phoneNumber?.phone)
            }
        ],
        notProvidedText
    );

export const buildRolesFields = (
    roles: string[],
    rolesLabel: string,
    notProvidedText: string
): InfoGridField[] =>
    toInfoGridFields(
        [{ fullWidth: true, label: rolesLabel, value: roles.join(ROLE_SEPARATOR) }],
        notProvidedText
    );
